export default __webpack_public_path__ + "media/images/historique-rouge-b85d5e4f9c2e04d36afff03a09fbaaf0.png";